import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Coffee, Cookie, CupSoda, BookOpen } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    title: 'Recetario de mixología con café',
    desc: '50 recetas para preparar bebidas únicas.',
    value: 9.99,
    icon: CupSoda,
    image: 'https://cdn.magicpatterns.com/uploads/bR5me2MvM8vVydBgJs65JK/20260317_1929_Image_Generation_remix_01kkyymsgrfmhbf6anqf9ww0b5.png'
  }, {
    title: 'Recetario de matcha',
    desc: '30 recetas modernas.',
    value: 7.99,
    icon: Coffee,
    image: 'https://cdn.magicpatterns.com/uploads/9tDi1hmbS3WNznp6PAXuQg/20260317_1932_Image_Generation_remix_01kkyyrnh7ft2a7czhfa1we4ys.png'
  }, {
    title: 'Recetario de mixología con té',
    desc: '40 recetas.',
    value: 7.99,
    icon: CupSoda,
    image: 'https://cdn.magicpatterns.com/uploads/1hL3SP9DZRhEvaS8RzU6S6/20260318_0854_Merienda_Minimalista_y_Refrescante_remix_01km0cqj3zegaawabxkfv8g96s.png'
  }, {
    title: 'Recetario de postres',
    desc: '50 postres ideales para acompañar tu café.',
    value: 9.99,
    icon: Cookie,
    image: 'https://cdn.magicpatterns.com/uploads/iiwLFJ5SFDjeCdPajsuuZp/20260318_0900_Image_Generation_remix_01km0d0m5pe6mty03zmskgxdcv.png'
  }, {
    title: 'Recetario de galletas',
    desc: '25 recetas.',
    value: 5.99,
    icon: Cookie,
    image: 'https://cdn.magicpatterns.com/uploads/wfuwYf2qTHEBPuDkzxfL9j/20260318_0908_Image_Generation_remix_01km0dh4gcf5bszwwtj4bbryav.png'
  }, {
    title: 'Recetario de barritas',
    desc: '25 recetas dulces.',
    value: 5.99,
    icon: Cookie,
    image: 'https://cdn.magicpatterns.com/uploads/m8erjSgQBPdVQyy3y8jueh/20260318_0911_Image_Generation_remix_01km0dpa06fbms7mg2q598c55b.png'
  }, {
    title: 'Recetario de batidos',
    desc: '30 bebidas refrescantes.',
    value: 7.99,
    icon: CupSoda,
    image: 'https://cdn.magicpatterns.com/uploads/hTQPtnfY5F6xLdEsEjEcJy/20260318_0911_Image_Generation_remix_01km0dpvsyfzvrptbafqe9g6gv.png'
  }, {
    title: 'Recetario de jarabes',
    desc: '10 jarabes estilo cafetería.',
    value: 4.99,
    icon: Coffee,
    image: 'https://cdn.magicpatterns.com/uploads/kmd6wA5FsgZ1qznC8GRxvY/20260318_0912_Image_Generation_remix_01km0dqmy2fagryrr2sjvcq1n1.png'
  }, {
    title: 'Mitos y verdades del café',
    desc: 'Descubre qué es mito y qué es realidad.',
    value: 3.99,
    icon: BookOpen,
    image: 'https://cdn.magicpatterns.com/uploads/4urKr8CYeotx9rf5Tr7tA9/20260318_0913_Image_Generation_remix_01km0ds5jyf57trq8m07fjkz6z.png'
  }, {
    title: 'Guía emprendedora: mi cafetería',
    desc: 'Convierte tu pasión en un posible negocio.',
    value: 12.99,
    icon: BookOpen,
    image: 'https://cdn.magicpatterns.com/uploads/psNykQre4i85jwmsd9u6ZJ/20260318_0913_Guia_Emprendedora_Cafeteria_remix_01km0dt7ytfbas1z86vknnacsz.png'
  }];
  const totalValue = bonuses.reduce((acc, curr) => acc + curr.value, 0);
  return <section className="py-10 md:py-14 px-4 bg-espresso-900 text-cream-100" data-id="element-12">
      <div className="max-w-4xl mx-auto" data-id="element-13">
        <div className="text-center mb-10" data-id="element-14">
          <div className="inline-flex items-center justify-center p-3 bg-gold-500/20 rounded-full mb-4" data-id="element-15">
            <Gift className="w-8 h-8 text-gold-500" data-id="element-16" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gold-500 mb-2" data-id="element-17">
            ADEMÁS INCLUYE{' '}
            <u className="decoration-cream-100 decoration-2 underline-offset-4" data-id="element-18">
              10 BONOS DE REGALO
            </u>
          </h2>
          <p className="text-lg text-cream-200" data-id="element-19">
            <em data-id="element-20">Exclusivos</em> al comprar <strong data-id="element-21">hoy</strong>
          </p>
        </div>

        <div className="space-y-4 mb-10" data-id="element-22">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          const hasImage = 'image' in bonus && bonus.image;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.04
          }} className="bg-espresso-800/50 border-l-4 border-gold-500 rounded-r-xl overflow-hidden hover:bg-espresso-800 transition-colors" data-id="element-23">
                <div className="p-4 flex flex-col sm:flex-row items-start sm:items-center gap-4" data-id="element-24">
                  {/* Thumbnail: image or icon */}
                  {hasImage ? <img src={(bonus as any).image} alt={bonus.title} className="w-20 h-20 sm:w-24 sm:h-24 rounded-lg object-cover flex-shrink-0 border-2 border-gold-500/30 shadow-lg" data-id="element-25" /> : <div className="bg-espresso-900 p-3 rounded-lg border border-espresso-700 flex-shrink-0" data-id="element-26">
                      <Icon className="w-6 h-6 text-gold-500" data-id="element-27" />
                    </div>}

                  <div className="flex-1 min-w-0" data-id="element-28">
                    <div className="text-gold-500 text-xs font-bold tracking-wider mb-0.5" data-id="element-29">
                      BONUS {index + 1}
                    </div>
                    <h3 className="text-lg font-bold leading-tight" data-id="element-30">
                      {bonus.title}
                    </h3>
                    <p className="text-cream-200/80 text-sm" data-id="element-31">{bonus.desc}</p>
                  </div>

                  <div className="flex flex-row sm:flex-col items-center sm:items-end gap-2 sm:gap-0 bg-espresso-900/50 px-3 py-1.5 rounded-lg flex-shrink-0" data-id="element-32">
                    <span className="text-sm line-through text-cream-200/40" data-id="element-33">
                      ${bonus.value}
                    </span>
                    <span className="text-cta-600 font-bold text-lg" data-id="element-34">
                      ¡GRATIS!
                    </span>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>

        {/* Total Value Summary */}
        <motion.div initial={{
        scale: 0.95,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-gold-600 to-gold-700 rounded-2xl p-6 md:p-8 text-center text-espresso-900 shadow-2xl relative overflow-hidden" data-id="element-35">
          <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-36"></div>
          <div className="relative z-10" data-id="element-37">
            <h3 className="text-xl md:text-2xl font-bold mb-4" data-id="element-38">
              Resumen de tu oferta hoy:
            </h3>
            <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-6 text-2xl md:text-3xl font-bold" data-id="element-39">
              <div className="flex flex-col items-center" data-id="element-40">
                <span className="text-xs uppercase tracking-widest opacity-80 mb-1" data-id="element-41">
                  Valor Total
                </span>
                <span className="line-through opacity-60" data-id="element-42">
                  ${totalValue.toFixed(2)}
                </span>
              </div>
              <span className="hidden md:inline" data-id="element-43">→</span>
              <div className="flex flex-col items-center" data-id="element-44">
                <span className="text-xs uppercase tracking-widest opacity-80 mb-1" data-id="element-45">
                  Hoy
                </span>
                <span className="text-white text-3xl md:text-4xl drop-shadow-md" data-id="element-46">
                  ¡GRATIS con tu compra!
                </span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}